import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    enterDetailsManually: 'Enter your details manually',
    goCapitalDeposit: 'I want to deposit my capital',

    separatorOr: 'or',
  },
  fr: {
    enterDetailsManually: 'Saisir les infos manuellement',
    goCapitalDeposit: 'Je souhaite déposer mon capital',

    separatorOr: 'ou',
  },
} as const);
